import { useCallback, useEffect, useRef } from "react";

/**
 * Päätös 99 (6.10.2026; malli 18b48fc, 89, 91): vain viimeisimmän pyynnön vastaus saa kirjoittaa tilaan.
 *
 *   const uusi = useViimeisin();
 *   const tuore = uusi();               // ennen hakua
 *   const x = await api.jotain(id);
 *   if (!tuore()) return;               // uudempi valinta on jo matkalla — vanha vastaus hylätään
 *
 * Purku mitätöi myös lennossa olevat. Kilpatilanne pakotetaan kävelyssä (kavely_kilpa99.mjs).
 */
export function useViimeisin(): () => () => boolean {
  const n = useRef(0);
  useEffect(() => () => { n.current++; }, []);
  return useCallback(() => { const oma = ++n.current; return () => oma === n.current; }, []);
}
